var toString = {}.toString;
var isType = function (value, type) {
  return toString.call(value) === '[object ' + type + ']';
};
export default isType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-type.js
// module id = 3
// module chunks = 0